import { useState } from 'react';

import useCreateSubCategory from '../../../../hooks/queries/category/useCreateSubCategory';
import useEditSubCategory from '../../../../hooks/queries/category/useEditSubCategory';
import useDeleteSubCategory from '../../../../hooks/queries/category/useDeleteSubCategory';
import { CATEGORY_STATUS_TYPE } from '../../../../constants/service/app/categoryConstants';

/**
 * 서브 카테고리 생성, 편집, 삭제 기능을 관리하는 hook
 * @param form
 * @param subCategoryList
 * @returns {{editSubCategory: ((function(*): Promise<void>)|*), newSubCategory: *[], editRow: editRow, cancelRow: ((function(): Promise<void>)|*), deleteSubCategory: ((function(*): Promise<void>)|*), removeRow: ((function(): Promise<void>)|*), createSubCategory: ((function(): Promise<void>)|*), editableRow: unknown, setEditableRow: (value: unknown) => void, addRow: addRow}}
 */
const useSubCategoryAction = (form, subCategoryList) => {
  const [editableRow, setEditableRow] = useState(null);
  const [newSubCategory, setNewSubCategory] = useState([]);

  const { createSubCategory } = useCreateSubCategory();
  const { editSubCategory } = useEditSubCategory();
  const { deleteSubCategory } = useDeleteSubCategory();

  const addRow = () => {
    form.setFieldsValue({
      name: null,
      status: CATEGORY_STATUS_TYPE.ACTIVE,
    });
    setNewSubCategory([
      {
        id: null,
        name: null,
        productCount: null,
        status: CATEGORY_STATUS_TYPE.ACTIVE,
        isExhibit: null,
        createDate: null,
        updateDate: null,
      },
    ]);
    setEditableRow(subCategoryList.length);
  };

  const editRow = (index, value) => {
    form.setFieldsValue({
      name: value.name,
      status: value.status,
    });
    setNewSubCategory([]);
    setEditableRow(index);
  };

  const resetRow = () => {
    setNewSubCategory([]);
    setEditableRow(null);
  };

  /**
   * 서브 카테고리 생성 및 편집 유효성 검사
   */
  const validateInputPolicy = ({ subId, data }) => {
    let pass = true;
    form.validateFields((err) => {
      if (err) {
        pass = false;
        return;
      }

      // * 카테고리명 중복 체크 조건
      // 편집 및 생성하는 카테고리가 활성 상태일 경우,
      // 서브 카테고리 리스트에서 활성 상태인 카테고리 중에서 카테고리명 중복 체크 (카테고리 편집 시 자신인 경우 제외)
      if (
        data.status === CATEGORY_STATUS_TYPE.ACTIVE &&
        subCategoryList
          .filter(({ status }) => status === CATEGORY_STATUS_TYPE.ACTIVE)
          .filter(({ id, name }) => name.trim() === data.name.trim() && id !== subId).length > 0
      ) {
        form.setFields({
          name: {
            value: data.name,
            errors: [new Error('중복된 카테고리가 있습니다.')],
          },
        });

        pass = false;
        return;
      }
    });

    return pass;
  };

  return {
    newSubCategory,
    editableRow,
    setEditableRow,
    addRow,
    editRow,
    resetRow,
    createSubCategory: createSubCategory.mutate,
    editSubCategory: editSubCategory.mutate,
    deleteSubCategory: deleteSubCategory.mutate,
    validateInputPolicy,
  };
};

export default useSubCategoryAction;
